import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://api.boltin.com';
const TYRO_REPORTS_PATH = '/api/tyro-reports';

export const fetchTyroReports = async (storeId, limit = 5) => {
  if (!storeId) throw new Error('storeId is required to fetch Tyro reports.');
  const response = await axios.get(`${API_BASE_URL}${TYRO_REPORTS_PATH}`, {
    params: { storeId, limit },
  });
  return response.data.data;
};

export const logTyroReport = async (payload) => {
  const response = await axios.post(`${API_BASE_URL}${TYRO_REPORTS_PATH}`, payload);
  return response.data.data;
};

const tyroReportsService = {
  fetchTyroReports,
  logTyroReport,
};

export default tyroReportsService;
